export const distanceUnits = {
  MILE: 'Mile',
  KM: 'Km',
}
